import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { CustomerSendingDomainQueryKeys } from "./keys";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import { AddSendingDomainRequest } from "../../models/CustomerSendingDomain/CustomerSendingDomain";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { ISendingDomain } from "../../models/CustomerSendingDomain/CustomerSendingDomain";

export default function useCustomerSendingDomainMutations(customerId: string) {
  const queryClient = useQueryClient();
  const { saveHandlers, deleteHandlers } = useDefaultCRUDHandlers("Sending domain");
  const { post, del } = useApiHelper();

  const add = useMutation({
    mutationFn: (req: AddSendingDomainRequest) =>
      post<IDefaultResponse<ISendingDomain>, AddSendingDomainRequest>(
        `/customer/${customerId}/sending-domains`,
        req
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: CustomerSendingDomainQueryKeys.all(customerId),
      });
      saveHandlers.onSuccess();
    },
    onError: () => {
      saveHandlers.onError();
    },
  });

  const verify = useMutation({
    mutationFn: (id: string) =>
      post<IDefaultResponse<ISendingDomain>>(
        `/customer/${customerId}/sending-domains/${id}/verify`,
        {}
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: CustomerSendingDomainQueryKeys.all(customerId),
      });
    },
  });

  const remove = useMutation({
    mutationFn: (id: string) =>
      del(`/customer/${customerId}/sending-domains/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: CustomerSendingDomainQueryKeys.all(customerId),
      });
      deleteHandlers.onSuccess();
    },
    onError: () => {
      deleteHandlers.onError();
    },
  });

  return {
    add,
    verify,
    remove,
  };
}
